'use client'

import { useTranslations } from 'next-intl'

import { formatLeaderboardNumber } from '@/features/leaderboard/formatLeaderboardNumber'
import { StatCard } from '@/shared/ui'

import S from './ClubProfileAnalytics.module.scss'
import AudienceBlocks from './components/AudienceBlocks'
import GrowthLocationCard from './components/GrowthLocationCard'

interface ClubProfileAnalyticsProps {
  fanViews?: number
  fanCount?: number
  tasksCompleted?: number
  earnedAp?: number
  isAthlete?: boolean
}

/**
 * The Analytics tab of the owner's cabinet: all-time Fans Views / Total fans
 * / Tasks completed / Earned AP, Gender, Age, Activity, Fan growth and
 * Location. No period filter in this iteration.
 */
const ClubProfileAnalytics = ({
  fanViews,
  fanCount,
  tasksCompleted,
  earnedAp,
  isAthlete = false
}: ClubProfileAnalyticsProps) => {
  const t = useTranslations('club.stats')

  return (
    <section className={S.analytics}>
      <div className={S.row}>
        <StatCard
          label={t('fansViews')}
          value={formatLeaderboardNumber(fanViews ?? 0)}
          hasGridBackground
        />
        <StatCard
          label={t('analytics.totalFans')}
          value={formatLeaderboardNumber(fanCount ?? 0)}
          hasGridBackground
        />
        <StatCard
          label={isAthlete ? t('tasksCompleted') : t('challengesCompleted')}
          value={formatLeaderboardNumber(tasksCompleted ?? 0)}
          hasGridBackground
        />
        <StatCard
          label={t('analytics.earnedAp')}
          value={formatLeaderboardNumber(earnedAp ?? 0)}
          hasGridBackground
        />
      </div>

      <div className={S.belowRow}>
        <div className={S.leftColumn}>
          <AudienceBlocks />
        </div>
        <GrowthLocationCard />
      </div>
    </section>
  )
}

export default ClubProfileAnalytics
